import * as React from 'react';
import { AppProvider } from '@toolpad/core/AppProvider';
import type { Navigation, Router } from '@toolpad/core';
import GroupIcon from '@mui/icons-material/Group';
import TerminalIcon from '@mui/icons-material/Terminal';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import HistoryToggleOffIcon from '@mui/icons-material/HistoryToggleOff';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import { layoutTheme } from '../LayoutTheme';
import { Toaster } from 'react-hot-toast'

const NAVIGATION: Navigation = [
  {
    segment: 'dashboard',
    title: 'Users',
    icon: <GroupIcon sx={{ fontSize: 40 }} />,
  },
  {
    segment: 'candidates',
    title: 'Candidates',
    icon: <TerminalIcon sx={{ fontSize: 40 }} />,
  },
  {
    segment: 'languages',
    title: 'Languages',
    icon: <TerminalIcon sx={{ fontSize: 40 }} />,
  },
  {
    segment: 'contests',
    title: 'Contests',
    icon: <EmojiEventsIcon sx={{ fontSize: 40 }} />,
  },
  {
    segment: 'training',
    title: 'My Training',
    icon: <MenuBookIcon sx={{ fontSize: 40 }} />,
  },
  {
    segment: 'challenges',
    title: 'Challenges',
    icon: <EmojiEventsIcon sx={{ fontSize: 40 }} />,
  },
  {
    segment: 'Interviews',
    title: 'Interviews',
    icon: <HistoryToggleOffIcon sx={{ fontSize: 40 }} />,
  },
  {
    segment: 'result',
    title: 'Result',
    icon: <HistoryToggleOffIcon sx={{ fontSize: 40 }} />,
  }
];

interface LayoutProps {
  children?: JSX.Element | JSX.Element[]
}

export default function Layout(props: LayoutProps) {
  const { children } = props
  const [pathname, setPathname] = React.useState('/dashboard')
  const router = React.useMemo<Router>(() => {
    return {
      pathname,
      searchParams: new URLSearchParams(),
      navigate: (path) => setPathname(String(path)),
    };
  }, [pathname]);

  return (
    <AppProvider
      navigation={NAVIGATION}
      router={router}
      theme={layoutTheme}
    >
      {children}
      <Toaster
        toastOptions={{
          success: {
            style: { background: '#208500' },
            iconTheme: {
              primary: '#fff',
              secondary: '#208500',
            },
          },
        }}
      />
    </AppProvider>
  );
}
